import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { CATEGORY_ADVANCED } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { PromoContext } from "@context/PromoContext";
import AlertMessage from "@components/AlertMessage";
import Footer from "@components/Footer/index.js";
import LogoBar from "@components/LogoBar";
import RedemptionsBar from "@components/RedemptionDetails/RedemptionsBar";

import "./style.scss";

const Welcome = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const { user, movieRedirect } = useContext(AuthContext);
    const { fetchApplyPromoAvailability, promoOptions, checkPromoReuse, reUseLimitReached } = useContext(PromoContext);

    const welcomePage = whiteLabel?.subscriber_group?.subscriber_group_welcome_page;

    const advancedPromos = promoOptions.filter((item) => Number(item.promo_category) === CATEGORY_ADVANCED);
    const promoDetails = (Array.isArray(advancedPromos) && advancedPromos.length > 0) ? advancedPromos[0] : null;

    // Build the movie redirect URL if we have the data
    const movieRedirectUrl = movieRedirect?.gifting
        ? "/gifting"
        : (movieRedirect?.venueName && movieRedirect?.movieUrl
            ? `/movie/${movieRedirect.movieUrl}?venue_name=${movieRedirect.venueName}`
            : null);

    useEffect(() => {
        if (user?.id) {
            fetchApplyPromoAvailability();
        }
    }, [user?.id]);

    useEffect(() => {
        if (promoDetails) {
            checkPromoReuse(promoDetails);
        }
    }, [promoOptions]);

    const hasText = (v) => typeof v === "string" && v.trim() !== "";

    const dynamicColorCss = [
        welcomePage?.page_title_color
            ? `.welcome__title{color:${welcomePage.page_title_color} !important;}`
            : "",
        welcomePage?.page_subtitle_color
            ? `.welcome__subtitle{color:${welcomePage.page_subtitle_color} !important;}`
            : "",
        welcomePage?.page_message_color
            ? `.welcome__text{color:${welcomePage.page_message_color} !important;}`
            : "",
    ].join("");

    return (
        <div className="welcome__wrapper">
            {dynamicColorCss && <style>{dynamicColorCss}</style>}

            <div className="container">
                <LogoBar />
            </div>

            <div className="welcome__content">
                {hasText(welcomePage?.page_title) && (
                    <h1 className="welcome__title">{welcomePage.page_title.trim()}</h1>
                )}

                {hasText(welcomePage?.page_subtitle) && (
                    <h2 className="welcome__subtitle">{welcomePage.page_subtitle.trim()}</h2>
                )}

                {promoDetails ? (
                    <RedemptionsBar
                        promoDetails={promoDetails}
                    />
                ) : null}

                {hasText(welcomePage?.page_message) && (
                    <div className="welcome__cta-wrapper">
                        <p className="welcome__text">{welcomePage.page_message.trim()}</p>
                        <div className="welcome__cta">
                            <Link
                                className="button button__primary"
                                to={movieRedirectUrl || "/"}
                            >
                                {welcomePage.page_button_text || "Find a session"}
                            </Link>
                        </div>
                    </div>
                )}

                {reUseLimitReached ? (
                    <div className="welcome__error-wrapper">
                        <AlertMessage
                            message="Monthly allocation exhausted, next allocation available on the 1st of next month."
                            type="error"
                        />
                    </div>
                ) : null}

            </div>
            <Footer />
        </div>
    );
};

export default Welcome;
